<template>
  <v-card>
    <v-toolbar class="bg-green-darken-3" height="75" dark>

      <v-toolbar-title>
        <div class="d-flex align-center ga-2">
          <img src="@/assets/images/gavi-logo.svg" alt="Logo" height="25" class="me-1" />
          <v-divider vertical />
          <span>Gestão Clínica</span>
        </div>
      </v-toolbar-title>

      <v-spacer />

      <!-- <v-btn class="me-3" icon="mdi-bell" size="small"></v-btn> -->
      <v-btn icon="mdi-exit-to-app" size="small" @click="handleLogout"></v-btn>
    </v-toolbar>

    <v-tabs v-model="tab" align-tabs="start" bg-color="grey-lighten-3">
      <v-tab v-for="item in filteredMenuItems" :key="item.name" :prepend-icon="item.icon" :to="item.route"
        :value="item.name" replace exact>
        {{ item.name }}
      </v-tab>
    </v-tabs>
  </v-card>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const route = useRoute();
const router = useRouter();
const auth = useAuthStore();

const menuItems = [
  { name: 'Dashboard', route: '/', icon: 'mdi-target' },
  { name: 'Atividades', route: '/atividades', icon: 'mdi-chart-bar' },
  { name: 'Usuários', route: '/usuarios', icon: 'mdi-account', adminOnly: true },
];

const filteredMenuItems = computed(() => {
  const user = auth.getUserData()
  return menuItems.filter(item => {
    if (!item.adminOnly) return true;
    if (!user) return false;
    return user.admin === '1';
  });

})

const tab = ref('Home');

watch(
  () => route.path,
  (newPath) => {
    const found = menuItems.find((item) => item.route === newPath);
    if (found) {
      tab.value = found.name;
    }
  },
  { immediate: true }
);

const handleLogout = async () => {
  await auth.logout();
  router.push('/login')
};
</script>
